import React from 'react';
import Locale from 'localization/Localization';
import { Button } from 'react-bootstrap';

interface ModalViewProps
{
	show: boolean;
	onClose: () => any;
}

export class ModalView extends React.Component<ModalViewProps, {}>
{
	public render()
	{
		// Don't render anything
		if (!this.props.show)
			return null;

		return (
			<div className='modal-container'>
				<div className='modal-content'>
					<div className='modal-header'>
						<Button variant='outline-primary' className='modal-button compact' onClick={this.props.onClose}>{Locale.get('modal_closeButton')}</Button>
					</div>
					{this.props.children}
				</div>
			</div>
		);
	}
}
